import { Injectable } from '@angular/core';
import { MiraieService } from './miraie.service';

@Injectable({
  providedIn: 'root'
})
export class PlaceService {

  constructor(
    private http: MiraieService,
  ) { }

  list() {
    var url = 'place/list';

    return this.http.post(url, {});
  }

  update(data) {
    var url = 'place/set';
    let param = { 'data': data };

    return this.http.post(url, param);
  }

  delete(place_id: number) {
    var url = 'place/del';
    let param = { 'place_id': place_id };

    return this.http.post(url, param);
  }
}
